import { Redirect } from 'react-router-dom';

import {
  freeTextbooksRootSelector,
  getFreeTextbooksEmptyViewUrl,
} from 'ms-pages/FreeTextbooks/urls';
import localStorageDb from 'ms-utils/localStorageDb';

export const LAST_SELECTED_FREE_TEXTBOOK_DB_KEY = 'LAST_SELECTED_FREE_TEXTBOOK';

export const setLastSelectedFreeTextbook = (syllabusId: string) => {
  localStorageDb.set(LAST_SELECTED_FREE_TEXTBOOK_DB_KEY, syllabusId);
};

export const getLastSelectedFreeTextbook = () => {
  return localStorageDb.get(LAST_SELECTED_FREE_TEXTBOOK_DB_KEY) || null;
};

export function FreeTextbooksRedirector() {
  const lastSelectedFreeTextbooks = getLastSelectedFreeTextbook();

  if (lastSelectedFreeTextbooks == null) {
    return <Redirect to={freeTextbooksRootSelector} />;
  }
  return (
    <Redirect
      to={getFreeTextbooksEmptyViewUrl({
        syllabusId: lastSelectedFreeTextbooks,
      })}
    />
  );
}
